enum PaymentOrderFeeState {
    NoFee = "NO_FEE",
    FeePending = "FEE_PENDING",
    FeePaid = "FEE_PAID",
    FeeFailed = "FEE_FAILED"
}
export default PaymentOrderFeeState